<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-textarea ttLabel="infotext" [ttModel]="edit.infotext" ttReadonly></tt-textarea>
        <tt-input ttLabel="businessco_companyname" [ttModel]="edit.businessco_companyname" ttReadonly></tt-input>
        <tt-select ttLabel="stockplace" [(ttModel)]="edit.stockplace_id" [ttData]="selectListStockPlaces" ttDataId="stockplace_id" ttDataName="stockplace_name" ttRequired></tt-select>
        <tt-button-save ttText="orderheadcreateibpurch_create" (ttClick)="createChanges()" [ttLoading]="creating"></tt-button-save>
    </tt-card>
</tt-page>
